import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      // text-base (16px) on mobile avoids iOS focus zoom that pans the whole UI
      "mt-1 flex h-10 w-full rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-base outline-none transition-colors placeholder:text-slate-400 focus-visible:border-amber-500 focus-visible:ring-1 focus-visible:ring-amber-500 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:placeholder:text-slate-500 md:text-sm",
      className
    )}
    {...props}
  />
));
Input.displayName = "Input";

